export enum EUnitType {
  POWER = "POWER",
  ENERGY = "ENERGY",
}
